import React, { Fragment } from 'react';
import IndexIndicator from '../../components/banggia/indexIndicator';
import PriceTable from '../../components/banggia/priceTable';

function Home({match: { params }}) {
  return (
    <Fragment>
      <IndexIndicator />
      <PriceTable categoryId={params.categoryId} />
    </Fragment>
  );
}

export default Home;
